<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YVqKnw/tc-custom/9781639843190.jpg?1704453933292" alt="This image is the cover for the book Orphans Preferred"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orphans Preferred
      </h1>
      <p class="bookDescription body article font2">
        <b>A</b><b> remarkable novel of a young boy whose dream of being a Pony Express rider teaches him the meaning of bravery, perseverance, and true friendship.</b><br/>  <br/> When Billy applies to the Pony Express, he doesn’t expect superintendent, Mr. Slade, to hire him as a farmhand for some remote relay station called Mud Springs. Amos, the station manager, is none too pleased either. Instead of a strong, full-grown farmhand, he’s sent a twelve-year-old boy.<br/>  <br/> As soon as he arrives at the Mud Springs station, Billy realizes he’s in for a challenge. Situated miles from anywhere, surrounded by vast stretches of bleak, dangerous land, the station is nothing more than a stable and a cramped soddy, managed by a grumpy man named Amos who can’t seem to keep his hired help.<br/>  <br/> Right from the start, tempers flare as Amos and Billy clash. While Amos is determined to prove that Billy is too young for the job, Billy sets out to show that he can do the job as well as any man and, hopefully, prove to Mr. Slade he has what it takes to be a Pony Express rider.<br/>  <br/> But life in such an isolated land is full of dangers. Amos and Billy soon discover they have bigger enemies than each other and need to join forces to save the station, the valuable horses, even their own lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Renee Vajko Srch, Faythe Payol
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen It! Publications, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0d06cea